module.exports = __webpack_public_path__ + "static/img/集团架构_banner.141973b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/集团架构_banner.png
// module id = iz7r
// module chunks = 1